import { Component, OnInit } from '@angular/core';

import { AppSW2 } from '../app-sw2';

import { AuthService } from '../auth.service';
import { LoadAppsSW2Service } from '../load-apps-sw2.service';

import { Router } from '@angular/router';

@Component({
  selector: 'app-choose-app',
  templateUrl: './choose-app.component.html',
  styleUrls: ['./choose-app.component.css']
})
export class ChooseAppComponent implements OnInit {

  available_apps: AppSW2[];
  active_apps: AppSW2[];
  app: AppSW2;
  lock: boolean = false;
  buttonDisabled: boolean = false;

  // DISPLAY POPUP ACTIVATION
  displayPopupActivationFreeOK: boolean;
  displayPopupActivationFreeKO: boolean;
  displayPopupUnavailable: boolean;

  selectedAppAvailable: AppSW2;
  selectedAppActive: AppSW2;

  constructor(
    private auth: AuthService,
    private loadAppsSW2: LoadAppsSW2Service,
    private router: Router
  ) { }

  ngOnInit() {
    this.getAppsSW2("available");
    this.getAppsSW2("active");
  }

  getAppsSW2(typeApps) {

    this.auth.getCurrentSession().subscribe(

      currSess => {
        console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.loadAppsSW2.getAppsSW2(idToken,typeApps,username).subscribe(
          data => {
            if(data.result == "OK") {
              if(typeApps == "available") {
                this.available_apps = data.items;
              } else {
                this.active_apps = data.items;
              }
            } else {
              alert("GETAPPSSW2 ERROR: " + data.error);
              console.log("GETAPPSSW2 ERROR: " + data.error);
            }
          },
          error => {
            alert("GETAPPSSW2 ERROR");
            console.log("Failed getAppsSW2: error = " + JSON.stringify(error, null, 2))
          }
        );
      },
      error => {
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2))
      }

    );

  } // end getAppsSW2

  activateApplSW2(applId) {

    this.auth.getCurrentSession().subscribe(

      currSess => {
        console.log("Successfull getCurrentSession: currSess = " + JSON.stringify(currSess, null, 2));
        let idToken = currSess.idToken.jwtToken;
        console.log("IdToken = " + idToken);
        let username = currSess.accessToken.payload.username;
        this.loadAppsSW2.activateApplSW2(idToken,applId,username).subscribe(
          data => {
            this.unlockScreen();
            this.enableActivateButton();
            if(data.result == "OK") {
              // alert("Applicazione " + applId + " attivata con abbonamento free");
              this.loadAppsSW2.activateSubscriptionFree(idToken,username).subscribe(
                data2 => {
                  if(data2.result == "OK") {
                    // public registerUser(idToken, username, nome, cognomeRagSoc, piva, codFiscale, indirizzo, cap, citta, provincia, nazione, telefono, dest_fe, pec_fe, email)
                    var nome = currSess.idToken.payload.given_name;
                    var cognomeRagSoc = currSess.idToken.payload.family_name;
                    var email = currSess.idToken.payload.email;
                    this.loadAppsSW2.registerUser(idToken,username,nome,cognomeRagSoc," "," "," "," "," "," "," "," "," "," ",email).subscribe(
                      data3 => {
                        if(data3.result == "OK") {
                          console.log("Utente registrato con successo")
                        } else if(data3.result == "ERR") {
                          alert("Errore registrazione utente: " + data3.error);
                          console.log("REGISTERUSER ERROR: " + data3.error);
                        } else {
                          alert("Errore generico registrazione utente: " + data3.result);
                          console.log("REGISTERUSER GENERIC ERROR: " + + JSON.stringify(data3, null, 2));
                        }
                      },
                      error => {
                        alert("Errore registrazione utente: " + JSON.stringify(error, null, 2));
                        console.log("REGISTERUSER ERROR: " + JSON.stringify(error, null, 2));
                      }
                    )
                    this.displayPopupActivationFreeOK = true;
                    this.getAppsSW2("available");
                    this.getAppsSW2("active");
                  } else if(data2.result == "ERR") {
                    alert("Errore attivazione sottoscrizione gratuita: " + data2.error);
                    console.log("ACTIVATESUBSCRIPTIONFREE ERROR: " + data2.error);
                  } else {
                    alert("Errore generico attivazione sottoscrizione gratuita: " + data2.result);
                    console.log("ACTIVATESUBSCRIPTIONFREE GENERIC ERROR: " + JSON.stringify(data2, null, 2));
                  }
                },
                error => {
                  alert("Errore attivazione sottoscrizione gratuita: " + JSON.stringify(error, null, 2));
                  console.log("ACTIVATESUBSCRIPTIONFREE ERROR: " + JSON.stringify(error, null, 2));
                }
              );
            } else if(data.result == "KO"){
              // alert("Applicazione già attivata");
              this.displayPopupActivationFreeKO = true;
            } else if(data.result =="UNAVAILABLE"){
              this.displayPopupUnavailable = true;
            } else if(data.result == "ERR") {
              alert("Errore attivazione applicazione: " + data.error);
              console.log("ACTIVATEAPPLSW2 ERROR: " + data.error);
            } else {
              alert("Errore generico attivazione sottoscrizione gratuita: " + data.result);
              console.log("ACTIVATEAPPLSW2 GENERIC ERROR: " + JSON.stringify(data, null, 2));
            }
          },
          error => {
            this.unlockScreen();
            this.enableActivateButton();
            alert("ACTIVATEAPPLSW2 ERROR");
            console.log("Failed activateApplSW2: error = " + JSON.stringify(error, null, 2));
          }
        );
      },
      error => {
        this.unlockScreen();
        this.enableActivateButton();
        alert("GETCURRENTSESSION ERROR");
        console.log("Failed getCurrentSession: error = " + JSON.stringify(error, null, 2));
      }

    );

  } // end activateApplSW2

  onRowSelectAvailable(event) {
    // alert("ONROWSELECTAVAILABLE, data: " + JSON.stringify(event.data));
    this.app = {...event.data};
  }

  onRowUnselectAvailable(event) {
    // alert("ONROWUNSELECTAVAILABLE, data: " + JSON.stringify(event.data));
    this.app = null;
  }

  onActivateButtonClick() {
    if(this.app == null) {
      alert("Nessuna applicazione selezionata");
    } else {
      // alert(JSON.stringify(this.app.APPL_ID));
      this.lockScreen();
      this.disableActivateButton();
      this.activateApplSW2(this.app.APPL_ID);
    }
  }

  lockScreen() {
    this.lock = true;
  }

  unlockScreen() {
    this.lock = false;
  }

  enableActivateButton() {
    this.buttonDisabled = false;
  }

  disableActivateButton() {
    this.buttonDisabled = true;
  }

  onRowSelectActive(event) {
    // alert("ONROWSELECTACTIVE, data: " + JSON.stringify(event.data));
    // this.app = {...event.data};
    var appSel = event.data.APPL_ID;
    if(appSel == "FACEGATE") {
      this.router.navigate(['/home']);
    } else {
      this.router.navigate(['/notavailable']);
    }
  }

  onRowUnselectActive(event) {
    // alert("ONROWUNSELECTACTIVE, data: " + JSON.stringify(event.data));
    // this.app = null;
  }

}
